module.exports = __webpack_public_path__ + "static/media/20ECE10.f34995b4.jpg";